import React from 'react';

//PACKS
import { connect } from 'react-redux';
import { Button, Alert, Navbar, Spinner } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { Form as FinalForm } from 'react-final-form';
import { UserPin } from '@styled-icons/boxicons-regular/UserPin';

//Containers
import ValidarCodigo from './ValidarCodigo';

//Components
import FormEsqueciSenha from '../../../components/forms/logins/FormEsqueciSenha';

//ACTIONS
import { codigoresetsenha } from '../../../actions/login/login';
import { codigoresetsenha as codigoresetsenhageren } from '../../../actions/logingerenciamento/login';

//TOOLS
import { getTraducaoTrocaPor as trad } from '../../../utils/getTraducoes';

class EsqueciSenha extends React.Component {

    state = {
        validarcodigo: false
    }
        
    onSubmit = async (form) => {

        let dados = {};
        switch (this.props.idcategoria) {
            case 3://Gerenciamento
                dados = await this.props.codigoresetsenhageren(form)
                break;
        
            default://Credenciamento
                const forms = {
                    idpromotora: this.props.idpromotora,
                    ...form
                }
                dados = await this.props.codigoresetsenha(forms)
                break;
        }
        
        if(dados&&dados.result===true){
            setTimeout(() => {
                this.setState({
                    validarcodigo: !this.state.validarcodigo?true:false
                });
            },5000)            
        }
    }

    render(){
        
        if(this.state.validarcodigo){
            return (
                <ValidarCodigo {...this.props} />
            );
        }
        
        return (
            <FinalForm 
            onSubmit={this.onSubmit}
            validate={ values => {
                const errors = {};
                if(!values.email){
                    errors.email = trad(this.props.trads,'ERROEMAIL1',this.props.lingua);
                }
                
                return errors;
            }}
            render={({form, pristine, submitting, handleSubmit}) => (
                <form onSubmit={handleSubmit}>
                    <Navbar bg="light" expand="lg" className="justify-content-center">
                        <Navbar.Brand>{trad(this.props.trads,'Informe seu e-mail',this.props.lingua)}</Navbar.Brand>
                        <UserPin size="60" />
                    </Navbar>
                    {
                    this.props.codigoReset&&this.props.codigoReset.result===false?
                    <Alert variant="warning">E-mail não encontrado!</Alert>
                    :
                    this.props.codigoReset&&this.props.codigoReset.result===true?
                    <Alert variant="success">Um código foi enviado para seu e-mail com as instruções para renovar a senha!</Alert>
                    :
                    null                    
                    }
                    <FormEsqueciSenha 
                    form={form}
                    {...this.props}                    
                    />
                    <Button          
                        id="btosubmit"               
                        variant="primary" 
                        size="lg" 
                        block 
                        type="submit"       
                        onClick={this.handleSubmitLog}
                        disabled={submitting || pristine}
                        >
                        {this.props.pendingTasks?
                        <Spinner animation="border"  />
                        :
                        trad(this.props.trads,'BT_AVANCAR2',this.props.lingua)
                        }
                    </Button>
                    <Button
                        variant="secondary" 
                        size="lg" 
                        block 
                        type="button"       
                        onClick={this.props.handleVoltar}                        
                        >
                        {trad(this.props.trads,'Voltar',this.props.lingua)}
                    </Button>
                </form>
            )}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        trads: state.reducerTraducoes,
        pendingTasks: state.pendingTasks,
        codigoReset: state.codigoResetSenhaReducer
    }
}

export default connect(mapStateToProps,{codigoresetsenha, codigoresetsenhageren})(withRouter(EsqueciSenha));